import React, { ChangeEvent, useState } from 'react';
import { navigate } from 'gatsby';
import paths from 'constants/paths';
import { TextField } from 'components/text-field';
import SearchIcon from 'assets/icons/searchIcon.svg';
import { Button } from 'components/button';
import * as styles from './profession.module.scss';

type SearchProfessionProps = {
  placeholder: string
  career: string
};

const SearchProfession = ({ placeholder, career }: SearchProfessionProps) => {
  const [queryInput, setQueryInput] = useState<string>('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setQueryInput(value);
  };
  const careerToPath = career.replace(' ', '%20');
  const handleEnter = (e: React.KeyboardEvent <HTMLInputElement>) => {
    if (e.key === 'Enter') {
      navigate(`${paths.searchPageAll}${queryInput}${paths.searchPageProfessionFilter}${careerToPath}`);
    }
  };
  const handleSearchClick = () => {
    navigate(`${paths.searchPageAll}${queryInput}${paths.searchPageProfessionFilter}${careerToPath}`);
  };
  return (
    <div className={styles.searchContainer}>
      <TextField
        name="search"
        placeholder={placeholder}
        onChange={handleChange}
        leftIcon={SearchIcon}
        value={queryInput}
        onKeyDown={handleEnter}
      />
      <Button onClick={handleSearchClick} className={styles.searchButton}>Search</Button>
    </div>
  );
};

export default SearchProfession;
